import React from "react";

import { Button, EmptyState, NotificationSnackbar, SectionCard, TextInput } from "shared/ui";

import { TablesManagementContext } from "features/TablesManagement/context";
import { useTablesManagementState } from "features/TablesManagement/hooks/useTablesManagementState";
import { BatchCreateDialog } from "features/TablesManagement/components/BatchCreateDialog";
import { DeleteTableDialog } from "features/TablesManagement/components/DeleteTableDialog";
import { TableDialog } from "features/TablesManagement/components/TableDialog";
import { TablesList } from "features/TablesManagement/components/TablesList";

import { Container, HeaderActions, Placeholder, SearchRow } from "./styles";

export const TablesManagement = () => {
    const state = useTablesManagementState();

    if (state.loading) {
        return <Container>Загрузка столов…</Container>;
    }

    if (state.error) {
        return <Container>Не удалось загрузить столы</Container>;
    }

    const renderContent = () => {
        if (state.totalCount === 0) {
            return (
                <EmptyState
                    title="Столов пока нет"
                    description="Гость выбирает стол при заказе внутри заведения, а сам стол привязывается к QR-коду. Добавьте столы по одному или сразу пачкой."
                    action={<Button onClick={state.openBatchDialog}>Добавить столы</Button>}
                />
            );
        }

        if (state.tables.length === 0) {
            return <Placeholder>По запросу «{state.search}» ничего не нашлось</Placeholder>;
        }

        return <TablesList />;
    };

    return (
        <TablesManagementContext.Provider value={state}>
            <Container>
                <SectionCard
                    title="Столы"
                    description="Номер стола гость выбирает при заказе — он же попадает на QR-код"
                    headerRight={
                        <HeaderActions>
                            <Button
                                variant="outlined"
                                color="neutral"
                                onClick={state.openBatchDialog}
                            >
                                Добавить несколько
                            </Button>
                            <Button onClick={state.openCreateDialog}>Добавить стол</Button>
                        </HeaderActions>
                    }
                >
                    {state.totalCount > 0 && (
                        <SearchRow>
                            <TextInput
                                value={state.search}
                                onChange={state.setSearch}
                                placeholder="Поиск по номеру, названию или внешнему ID"
                            />
                        </SearchRow>
                    )}

                    {renderContent()}
                </SectionCard>

                <TableDialog />
                <BatchCreateDialog />
                <DeleteTableDialog />

                <NotificationSnackbar {...state.notify.snackbarProps} />
            </Container>
        </TablesManagementContext.Provider>
    );
};
